import { FETCH_STORE_CREDIT_REQUEST, FETCH_STORE_CREDIT_SUCCESS, FETCH_STORE_CREDIT_ERROR } from '../constants'

export default function isFetchingStoreCredit(state = false, action) {
    switch (action.type) {
        case FETCH_STORE_CREDIT_REQUEST:
            return true
        case FETCH_STORE_CREDIT_SUCCESS:
        case FETCH_STORE_CREDIT_ERROR:
            return false
        default:
            return state
    }
}
